import React from 'react';
import { Link } from 'react-router-dom';
import SocialLinks from './SocialLinks';

function Footer() {
  return (
    <footer className="tc-footer-style1 border-top">
      <div className="container">
        <div className="top-content section-padding">
          <div className="row gx-0">
            <div className="col-lg-4">
              <div className="info-side">
                <div className="text fsz-24 color-333 lh-3 fw-600">
                  We believe that every space has its own story. Dynamic Decor&lsquo;s 
                  philosophy is to provide high-quality PVC and interior 
                  solutions that combine durability with modern aesthetics.
                </div>
                <SocialLinks className="foot-social mt-50" />
              </div>
            </div>
            <div className="col-lg-3 offset-lg-2">
              <div className="branch-card">
                <h5 className="mb-20 mt-5 mt-lg-0 fw-600"> Dynamic Decor </h5>
                <ul className="footer-links">
                  <li>
                    <a
                      href="https://maps.google.com/maps?q=Delby%20Dynamic%20Decor"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Delby Dynamic Decor · Google Maps
                    </a>
                  </li>
                  <li>
                    <a href="mailto:hellodynamicdecor@gmail.com"> hellodynamicdecor@gmail.com </a>
                  </li>
                  <li>
                    <a href="tel:+917006249084"> +91 70062 49084 </a>
                  </li>
                  <li>
                    <a href="tel:+917889944522"> +91 78899 44522 </a>
                  </li>
                </ul>
              </div>
              <div className="branch-card">
                <h5 className="mb-20 mt-5 fw-600"> Products </h5>
                <ul className="footer-links">
                  <li>
                    <a href="#0"> Premium PVC Panels </a>
                  </li>
                  <li>
                    <a href="#0"> Luxury Wallpapers </a>
                  </li>
                  <li>
                    <a href="#0"> Custom Interior Design </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="branch-card">
                <h5 className="mb-20 mt-5 mt-lg-0 fw-600"> Real Interior </h5>
                <ul className="footer-links">
                  <li>
                    <span className="d-inline-block">
                      Shopping complex tancha bagh Pampore 192121
                    </span>
                  </li>
                  <li>
                    <a href="mailto:hellodynamicdecor@gmail.com"> hellodynamicdecor@gmail.com </a>
                  </li>
                  <li>
                    <a href="tel:+918899445227"> +91 88994 45227 </a>
                  </li>
                </ul>
              </div>
              <div className="branch-card">
                <h5 className="mb-20 mt-5 fw-600"> Support </h5>
                <ul className="footer-links">
                  <li>
                    <a href="#0"> Term & Conditions </a>
                  </li>
                  <li>
                    <a href="#0"> Partner Policy </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="foot">
          <div className="row">
            <div className="col-lg-6">
              <p className="fsz-13 copyright">© 2024 Made by Dynamic Decor. All Rights Reserved.</p>
            </div>
            <div className="col-lg-6 text-lg-end">
              <div className="foot-links mt-4 mt-lg-0">
                <Link to="/"> Home </Link>
                <Link to="/collection"> Our Collection </Link>
                <Link to="/portfolio"> Portfolio </Link>
                <Link to="/services"> Services </Link>
                <Link to="/about"> About </Link>
                <Link to="/contact"> Contact </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
